import React, { useEffect, useState, useRef } from 'react';
import '../css/finance.css'; // Common styles for info blocks
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js'
import { t } from 'ttag';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import { Turl } from '../components/tUrl.js'
import { Loading } from '../components/loading.js';

DataTable.use(DT);
const tg = window.Telegram ? window.Telegram.WebApp : null;

function Finance({ recData, handlesetIndex }) {

    const [mData, setmData] = useState(null);
    const hasFetchedData = useRef(false); // Ref для отслеживания первого вызова

    useEffect(() => {
        const getData = async () => {
            hasFetchedData.current = true;

            try {
                const _userData = tg ? tg.initData : null;
                let userData = { initData: _userData }


                if (userData) {
                    const response = await fetch(Turl + '/st/transactions', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userData)
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    let rd = await response.json();
                    setmData(rd)

                } else {
                    console.warn("Telegram user data not available.");
                }

            } catch (error) {
                console.error('Authentication error:', error);
            }
        };

        if (!mData && !hasFetchedData.current) {
            getData();
        }
    }, [mData]);

    if (!mData)
        return <Loading />;
    hasFetchedData.current = false;


    // --- Блок Баланса и Кнопок (Редизайн) ---
    const bal = (
        <>
            <div className="f-balance-card">
                <div className="f-balance-label">{t`Balance`}</div>
                <div className="f-balance-value">{formatNumberWithCommas(parseFloat(recData.usdt), 4)} USDT</div>
            </div>
          <div className="f-balance-card">
                <div className="f-balance-label">{t`You USDT BEP-20 address`}</div>
                <div className="f-wallet-value">{recData.wallet}</div>
            </div>
            <div className="f-button-container">
                <button className="f-action-button" onClick={() => { handlesetIndex(41) }}>
                    {t`Deposit`}
                </button>
                <button className="f-action-button" onClick={() => { handlesetIndex(42) }}>
                    {t`Withdrawal`}
                </button>
            </div>
        </>
    );

    // --- Блок Таблицы ---
    const trans = (
        <div className="fTHDataTable">
            <div className="ftable-responsive">
                <DataTable
                    data={mData.transactions}
                    className="display dark cell-border compact stripe"
                    options={{
                        searching: false,
                        autoWidth: true,
                        layout: { topStart: null },
                        order: [[1, 'desc']],

                    }}
                    columns={[
                        { data: 'Details' },
                        { data: 'dt' },
                        { data: 'amount' },
                    ]}
                >
                    <thead>
                        <tr>
                            <th>{t`Details`}</th>
                            <th style={{ width: "30%" }}>{t`Date`}</th>
                            <th style={{ width: "20%" }}>{t`Amount`}</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>
        </div>
    );

    return <>{bal} {trans} </>
}

export { Finance };